import { ReactNode } from 'react';
import * as deviceDetect from 'react-device-detect';
import DriveCharge, { PAGE_TYPE } from '@elem/compCommon/DriveCharge';
import css from './deltapro.module.scss';
import Bannervideo from './components/bannervideo';
import MultiCharge from './components/multicharge';
import TabInfo from './components/tabinfo';
import TailA1 from './components/tailA/tailA1';
import TailA2 from './components/tailA/tailA2';
import CardmsgA1 from './components/cardmsgA/cardmsgA1';
import CardmsgA2 from './components/cardmsgA/cardmsgA2';
import CardmsgB1 from './components/cardmsgB/cardmsgB1';
import CardmsgB2 from './components/cardmsgB/cardmsgB2';
import CardmsgB3 from './components/cardmsgB/cardmsgB3';
import CardmsgC1 from './components/cardmsgC/cardmsgC1';
import CardmsgC2 from './components/cardmsgC/cardmsgC2';
import CardmsgC3 from './components/cardmsgC/cardmsgC3';
import CardmsgD1 from './components/cardmsgD/cardmsgD1';
import CardmsgD2 from './components/cardmsgD/cardmsgD2';
import CardmsgD3 from './components/cardmsgD/cardmsgD3';
import CardmsgE1 from './components/cardmsgE/cardmsgE1';
import OverView from './components/OverView';
import OverViewNew from './components/OverViewNew';
import Section18 from './components/Section18';
import Section19 from './components/Section19';
import TabInfo2 from './components/tabinfo2';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import OtherList from '@/components/ProductCommon/OtherList';
import { getImageSpec } from '@/utils/locals';
import IRAFooter from '@/components/IRAComp/IRAFooterNew';
import { createEFPic } from '@/utils/useEFPic';
import AppPointDeltaAdv from '@/components/AppPoint/DeltaAdvH5';
import { SHOW_APP_POINT_SITES } from '@/constants';
import PDFActivity from 'elem/compCommon/PillarPageActivities/PDFActivity';
import QuoteWinFloat from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWinFloat';
import QuoteWin from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWin';
import { useState, useEffect } from 'react';
import ProductRecommand from '@elem/compCommon/ProductRecomand';
import { ItfProductRecommandProps } from '@elem/compCommon/ProductRecomand/type';

const { EFPic } = createEFPic('/media/deltapro/h5/');
const isIOS = deviceDetect.isIOS;
const product: any = {
    cis: ['product_ps_delta_delta_2', 'product_ps_delta_delta_max', 'product_ps_river_river_256'],
    us: ['product_ps_delta_delta_1300', 'product_ps_delta_delta_max'],
    eu: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    uk: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    de: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    fr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    it: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    es: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    tw: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    kr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    cn: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    br: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
    mx: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
    nl: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
    ph: ['product_ps_river_703', 'product_ps_delta_delta_3', 'product_ps_delta_delta_2'],
};
const showNewComponents = ['us', 'ca', 'uk', 'de', 'fr', 'it', 'es', 'cis', 'br', 'mx', 'ph'];

export default function Deltapro() {
    const { gloproductlist, useLang, useRouter, Link } = useGlobal();
    const { t } = useLang('delta_pro_new');
    const { locale, query } = useRouter();
    const imgSpec = getImageSpec(locale, ['uk', 'au', 'jp', 'cn', 'de', 'fr', 'es', 'it', 'eu', 'za', 'ph', 'nl']);
    const now = query?._timer ? new Date(query?._timer).getTime() : new Date().getTime();
    const times = {
        us: '2024/09/23 15:00:00 GMT+8',
    };
    const IS_ACTIVE = now >= new Date(times[locale]).getTime();
    const [isClient, setIsClient] = useState(false);
    const [openQuoteFlag, setOpenQuoteFlag] = useState(false);

    const props: ItfProductRecommandProps = {
        theme: 'black',
        more: `https://${locale}.ecoflow.com/collections/smart-devices`,
        data: [
            {
                productId: '9935698034964',
                variantId: '51194372948244',
            },
            {
                productId: '9935697510676',
                variantId: '51194371211540',
            },
            {
                productId: '9935709536532',
                variantId: '51194412302612',
            },
        ],
    };

    const quoteCallback = (type: string) => {
        if (type === 'close') {
            setOpenQuoteFlag(false);
        } else if (type === 'open') {
            setOpenQuoteFlag(true);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            <div className={`${css.deltaproWrapper} deltapro-wrapper ${isIOS ? ' isIOS' : ''}`}>
                <div className={`${isIOS ? ' isIOS' : ''}`}>
                    <Bannervideo icon="/icons/video_play_gray.svg" />
                    {locale === 'us' && !IS_ACTIVE && <PDFActivity />}
                    {/* 新版本一图看懂 */}
                    {showNewComponents.includes(locale) ? <OverViewNew /> : <OverView />}
                    <div className="content-msg1">
                        <div className="msg-line1">{t('3Pt6kWh_25kWh_capacity')} </div>
                        <div className="msg-line2" dangerouslySetInnerHTML={{ __html: t.raw('power_your_home') }}></div>
                        <div className="msg-line3">{t('capactity_desc')} </div>
                    </div>
                    <div className="content-img2 GtmModuleData-section" data-section-id={'content-img2'} data-section-title={t('delta_pro_expandable')}>
                        {locale == 'jp' ? (
                            <EFPic name={[`lighting.webp`, `lighting.jpg`]} className="fullImgs lighting-img" alt={t('delta_pro_expandable')} />
                        ) : (
                            <EFPic name={[`img2.webp`, `img2.png`]} className="fullImgs" alt={t('delta_pro_expandable')} />
                        )}
                    </div>
                    <div className="page-box1">
                        <TabInfo />
                    </div>
                    <div className="content-msg2 GtmModuleData-section" data-section-id={'content-msg2'} data-section-title={t('AC_output')}>
                        <div className="msg-line1">{t('AC_output')} </div>
                        {t.rich('AC_output_sub_title', {
                            line1: (child: ReactNode) => <div className="msg-line2">{child}</div>,
                            line1_1: (child: ReactNode) => <div>{child}</div>,
                            line1_2: (child: ReactNode) => <div>{child}</div>,
                            line2: (child: ReactNode) => <div className="msg-line3">{child}</div>,
                        })}
                        <div className="msg-line4">{t('AC_output_desc')} </div>
                        <div className="msg-line5">
                            {t.rich('AC_output_notice', {
                                line1: (text: string) => (
                                    <Link className="ef-link__page is-mobile" href="/x-boost" newWin>
                                        {text}
                                    </Link>
                                ),
                                div: () => <div></div>,
                            })}
                        </div>
                    </div>
                    <div className="content-img3 GtmModuleData-section" data-section-id={'content-img3'} data-section-title={t('AC_output')}>
                        {locale == 'jp' ? (
                            <EFPic name={[`indoor.webp`, `indoor.jpg`]} className="fullImgs" alt={t('AC_output')} />
                        ) : locale === 'ph' ? (
                            <img src="https://websiteoss.ecoflow.com/upload/image/1751093366740/2-h5.jpg" className="fullImgs" alt={t('AC_output')} />
                        ) : (
                            <EFPic name={[`img06_${imgSpec}.webp`, `img06_${imgSpec}.png`]} className="fullImgs" alt={t('AC_output')} />
                        )}
                    </div>
                    <div
                        className="content-msg3 content-msg3-2 GtmModuleData-section"
                        data-section-id={'content-msg3-2'}
                        data-section-title={t('AC_output_desc2')}
                    >
                        <div className="msg-line1">{t('AC_output_desc2')} </div>
                    </div>
                    <div className="content-img4 GtmModuleData-section" data-section-id={'content-img4'} data-section-title={t('AC_output')}>
                        {locale == 'jp' ? (
                            <EFPic name={[`outdoor.webp`, `outdoor.jpg`]} className="fullImgs" alt={t('AC_output')} />
                        ) : locale === 'ph' ? (
                            <img src="https://websiteoss.ecoflow.com/upload/image/1751093366387/1-h5.jpg" className="fullImgs" alt={t('AC_output')} />
                        ) : (
                            <EFPic name={[`img07_${imgSpec}.webp`, `img07_${imgSpec}.png`]} className="fullImgs" alt={t('AC_output')} />
                        )}
                    </div>
                    {locale == 'jp' && <TabInfo2 />}
                    <div className="content-msg4 content-msg4-2 GtmModuleData-section" data-section-id={'content-msg4-2'} data-section-title={t('flow_charge')}>
                        <div className="msg-line1">{t('flow_charge')}</div>
                        <div className="msg-line2">{t('flow_charge_desc')}</div>
                    </div>
                    <div className="card-slider ">
                        <CardmsgE1
                            cssStyle={{
                                list: {
                                    listHeight: ['fr', 'es'].includes(locale) ? 5.2 : 4.4,
                                },
                            }}
                        />
                        {['cn', 'tw'].includes(locale) && <p className="sec10-memo">{t('sec10_memo')}</p>}
                    </div>
                    <div className="page-box2">
                        <MultiCharge />
                    </div>
                    <DriveCharge locale={locale} pageType={PAGE_TYPE.DELTA_PRO} />
                    {showNewComponents.includes(locale) && <Section18 />}
                    {['us', 'br', 'mx'].includes(locale) && <Section19 />}
                    {!['nl'].includes(locale) && (
                        <>
                            <CardmsgA1 />
                            <TailA1 />
                            <CardmsgA2 />
                            <TailA2 />
                        </>
                    )}
                    <div
                        className="content-msg-a content-msg-a1 GtmModuleData-section"
                        data-section-id={'content-msg-a1'}
                        data-section-title={t('battery_technology')}
                    >
                        <div className="msg-line1">{t('battery_technology')}</div>
                        <div className="msg-line2">{t('battery_technology_sub_title')}</div>
                    </div>
                    <CardmsgB1 />
                    <CardmsgB2 />
                    <CardmsgB3 />
                    <div
                        className="content-msg-a content-msg-a2 GtmModuleData-section"
                        data-section-id={'content-msg-a2'}
                        data-section-title={t('interior_exterior_design')}
                    >
                        <div className="msg-line1">{t('interior_exterior_design')}</div>
                        <div className="msg-line2">
                            {['cn', 'tw'].includes(locale)
                                ? t('interior_exterior_design_sub_title_h5')
                                : t.rich('interior_exterior_design_sub_title', {
                                    line1: (child: ReactNode) => <div>{child}</div>,
                                    line2: (child: ReactNode) => <div>{child}</div>,
                                    line3: (child: ReactNode) => <div>{child}</div>,
                                })}
                        </div>
                        <div className="msg-desc1">{t('interior_exterior_design_desc')}</div>
                    </div>
                    <CardmsgC1 />
                    <CardmsgC2 />
                    <CardmsgC3 />
                    <div className="content-msg-b">
                        <div className="msg-line1">{t('control_consumption')}</div>
                    </div>
                    <CardmsgD1 />
                    <CardmsgD2 />
                    {SHOW_APP_POINT_SITES.includes(locale) && <AppPointDeltaAdv />}
                    <CardmsgD3 />
                    {['us', 'br', 'mx'].includes(locale) && <IRAFooter borderTopColor="transparent" />}
                    {['nl'].includes(locale) ? (
                        <ProductRecommand {...props} />
                    ) : (
                        <OtherList
                            theme="black"
                            data={getDetaileMoreProducts(
                                gloproductlist,
                                product[locale] || product.us,
                                '',
                                '',
                                `https://${locale}.ecoflow.com/collections/portable-power-stations`,
                            )}
                        />
                    )}
                </div>
            </div>
        </>
    );
}
